import React from 'react';
import { oneOfType, number, string } from 'prop-types';

NumberedCircle.propTypes = {
  cx: number,
  cy: number,
  rotate: number,
  children: oneOfType([number, string]),
  id: string,
  floorLevel: number
};

function NumberedCircle({ rotate, cx: initialCx, cy: initialCy, circleSize = 10, children, id, floorLevel }) {
  const circleRadius = 4;

  return (
    <g 
      transform={`rotate(-${rotate} ${initialCx} ${initialCy})`}
    >
      <g transform={`translate(${initialCx} ${initialCy})`}>
        <circle
          style={{
            fill: '#F9A54E',
            strokeMiterlimit:10
          }}
          r={circleRadius}
        >
        </circle>
        <text
          dy=".4em"
          fontSize="5"
          stroke="#282827"
          letterSpacing="0.9"
          strokeWidth="0.5px"
          textAnchor="middle"
          style={{ userSelect: 'none' }}
        >
          {children}
        </text>
      </g>
    </g>
  );
}

export default NumberedCircle;